import React from 'react'
import { render } from 'react-dom'

import Header from './components/header'
import Projects from './components/projects'
import Footer from './components/footer'


class App extends React.Component {

  // ** LIFECYCLE METHODS ** //

  constructor(props) {
    super(props)

    this.state = {
      projects: []
    }
    
    this.isNavShowing = this.isNavShowing.bind(this)
    this.isNavActive = this.isNavActive.bind(this)
    this.projectAnimations = this.projectAnimations.bind(this)
  }

  componentDidMount() {
    this.state.projects = document.querySelectorAll('.project')
    this.state.shapes = document.querySelector('.project__shapes')
    this.state.scrollAnchors = document.querySelectorAll('.scrollTo')


    window.addEventListener('resize', this.projectAnimations)
    window.addEventListener('scroll', this.projectAnimations)

    window.addEventListener('scroll', this.isNavShowing)
    window.addEventListener('scroll', this.isNavActive)
  }

  // ** APP METHODS ** //

  isNavShowing() {
    var scrt = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0)
    var win_h = document.documentElement.clientHeight
    
    if (scrt >= 350 && (scrt + win_h !== document.body.offsetHeight) ) {
      document.querySelector('.project__nav').classList.add('showing')
    } else if ( (scrt >= 350) && (scrt + win_h >= document.body.offsetHeight)) {
      document.querySelector('.project__nav').classList.remove('showing')
    } else {
      document.querySelector('.project__nav').classList.remove('showing')
    }
  }

  isNavActive() {
    // variables
    var scrt = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0),
        win_h = window.innerHeight, 
        win_w = window.innerWidth,
        d_h = document.getElementsByTagName('body')[0].offsetHeight;   
    
    // current project
    for(var i=0;i<this.state.projects.length;i++){
      var p = this.state.projects[i],
          top = scrt + p.getBoundingClientRect().top,
          h = p.clientHeight || p.offsetHeight || p.scrollHeight,
          startY = top + 100, // + 100
          stopY = top + h, // - 50
          totalY = stopY - startY,
          listItems = document.querySelectorAll('.project__list__item');

      if((scrt + win_h) >= startY && (scrt + win_h) <= stopY){

        let currentProject = this.state.projects[i].getAttribute('id')
        
        for (i = 0; i < listItems.length; ++i) {
          if (listItems[i].getAttribute('data-alink') == currentProject) {
            listItems[i].classList.add('current')
          } else {
            listItems[i].classList.remove('current')
          }
        }
      }
    }            
  }

  projectAnimations() {
    var scrt = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0),
        win_h = window.innerHeight, 
        win_w = window.innerWidth,
        d_h = document.getElementsByTagName('body')[0].offsetHeight;    
    
    // projects animation
    for(var i=0;i<this.state.projects.length;i++){
      var p = this.state.projects[i],
          top = scrt + p.getBoundingClientRect().top,
          h = p.clientHeight || p.offsetHeight || p.scrollHeight,
          startY = top,
          stopY = top + h - 50,
          totalY = stopY - startY,
          title = p.querySelector('.scrollFirst'),
          role = p.querySelector('.scrollSecond'),
          details = p.querySelector('.scrollThird'),
          description = p.querySelector('.project__description'),
          img = p.querySelector('.project__image__container'),
          trans = 'translate3d(0,0,0)';

      if((scrt + win_h) >= startY && (scrt + win_h) <= stopY){

        var percentage = (scrt + win_h - startY) / totalY;

        if(img != undefined){

          var imgTop = 100 * (1 - percentage),
              titleTop = 120 * (1 - percentage),
              roleTop = 130 * (1 - percentage),
              detailsTop = 200 * (1 - percentage),
              imgTranslation = 'translate3d(0,' + imgTop + 'px' + ',0)',
              titleTranslation = 'translate3d(0,' + titleTop + 'px' + ',0)',
              roleTranslation = 'translate3d(0,' + roleTop + 'px' + ',0)',
              detailsTranslation = 'translate3d(0,' + detailsTop + 'px' + ',0)';
          
          img.style.cssText = '-webkit-transform:'+imgTranslation+';-moz-transform:'+imgTranslation+';transform:'+imgTranslation+';';
          title.style.cssText = '-webkit-transform:'+titleTranslation+';-moz-transform:'+titleTranslation+';transform:'+titleTranslation;
          role.style.cssText = '-webkit-transform:'+roleTranslation+';-moz-transform:'+roleTranslation+';transform:'+roleTranslation;
          details.style.cssText = '-webkit-transform:'+detailsTranslation+';-moz-transform:'+detailsTranslation+';transform:'+detailsTranslation;

        }
      }
    }    
  }

  // ** RENDER METHODS ** //

  render() {
    return(
      <div>
      	<Header />
        <Projects />
        <Footer />
      </div>
    )
  }
}

const mount = document.getElementById('app')

render(( <App /> ), mount)


/** WEBPACK FOOTER **
 ** ./js/main.js
 **/